import billingModule from '../../billing.module';
import template from './billingModalProducts.component.html';
import style from './billingModalProducts.component.css';

export default billingModule.component('billingModalProducts', {
    template,
    style,
    bindings: {
        close: '&',
        dismiss: '&',
        modalInstance: '<',
        resolve: '<'
    },
    controller(
        asNotifier,
        billingActionService,
        billingProductService,
        textResources
    ) {
        var vm = this;

        vm.$onInit = () => {
            vm.render();
        };

        vm.render = () => {
            vm.isRendering = true;

            billingProductService
                .getProducts()
                .then(
                    data => {
                        vm.products = data.items;
                    },
                    () => {
                        asNotifier.error(
                            `${textResources.genericError} ${
                                textResources.ifProblemPersists
                            }`
                        );
                    }
                )
                .finally(() => {
                    vm.isRendering = false;
                });
        };

        vm.callback = (success, resolve) => {
            if (!success && !resolve.close) {
                billingActionService.openModalProducts(resolve);
            }
        };
    }
});



// WEBPACK FOOTER //
// ./modules/billing/components/billing-modal-products/billingModalProducts.component.js